import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { Image } from 'expo-image';

import { useTheme, type ThemeColors } from '../../utils/theme';

const whishLogo = require('../../assets/payments/whish-logo.svg');

type WhishMarkProps = {
  size?: 'sm' | 'md';
  variant?: 'solid' | 'outline';
};

export default function WhishMark({ size = 'md', variant = 'solid' }: WhishMarkProps) {
  const { colors } = useTheme();
  const s = useMemo(() => createStyles(colors, size, variant), [colors, size, variant]);

  return (
    <View style={s.mark} pointerEvents="none" accessible={false}>
      <Image source={whishLogo} style={s.logo} contentFit="contain" />
    </View>
  );
}

const createStyles = (colors: ThemeColors, size: NonNullable<WhishMarkProps['size']>, variant: NonNullable<WhishMarkProps['variant']>) => {
  const isSmall = size === 'sm';
  const isOutline = variant === 'outline';

  return StyleSheet.create({
    mark: {
      width: isSmall ? 58 : 76,
      height: isSmall ? 26 : 34,
      borderRadius: isSmall ? 8 : 10,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: isOutline ? colors.card : '#fff',
      borderWidth: 1,
      borderColor: isOutline ? colors.border : 'rgba(15, 118, 110, 0.16)',
      shadowColor: '#0f172a',
      shadowOpacity: isOutline ? 0 : 0.12,
      shadowRadius: 6,
      shadowOffset: { width: 0, height: 3 },
      elevation: isOutline ? 0 : 2,
    },
    logo: {
      width: isSmall ? 48 : 64,
      height: isSmall ? 14 : 18,
    },
  });
};
